import { FC, useState } from "react";
import ImageComponent from "../../atoms/ImageComponent";
import LinkComponent from "../../atoms/LinkComponent";
import logo from "./../../../../../assets/Navbar/ZOWN-Blue-logo-no-slogan.svg";
import chevronRight from "./../../../../../assets/Navbar/chevronRightIcon.png";
import arrowRightBlackSmall from "./../../../../../assets/Navbar/arrowRightBlackSmall.svg";
import CloseMenuIconBtn from "./CloseMenuIconBtn";
import ButtonComponent from "../../atoms/ButtonComponent";
import MainPage from "./pages/MainPage";
import { MenuNames } from "../../header";
import useNavigator from "./useNavigation";
import BuyPage from "./pages/BuyPage";
import BuyToolsPage from "./pages/BuyToolsPage";
import BuyResourcesPage from "./pages/BuyResourcesPage";
import SellPage from "./pages/SellPage";
import SellBuyPage from "./pages/SellBuyPage";
import SellToolsPage from "./pages/SellToolsPage";
import SellResourcesPage from "./pages/SellResourcesPage";
import SellBuyToolsPage from "./pages/SellBuyToolsPage";
import SellBuyResourcesPage from "./pages/SellBuyResourcesPage";

type IProps = {
  handleClose: () => void;
};

const MobileNavMenus: FC<IProps> = ({ handleClose }) => {
  const {
    currentNode,
    onPageChange,
    goBack,
    getParentOfCurrentNode,
    resetState,
  } = useNavigator();

  const handleCLoseModel = () => {
    resetState();
    handleClose();
  };
  return (
    <div id="mobile-nav-menu" role="dialog" aria-modal="true">
      {/* <!-- Background backdrop, show/hide based on slide-over state. --> */}
      <div
        onClick={() => {
          handleCLoseModel();
        }}
        className="fixed inset-0 z-50 bg-[#1a1a1a] bg-opacity-20 overlay text-[#1a1a1a]"
      ></div>
      {/* <!-- MAIN PAGE --> */}
      {currentNode.name === "main" ? (
        <MainPage
          navigateFn={(target) => {
            onPageChange(target);
          }}
          handleReset={() => {
            handleCLoseModel();
          }}
        />
      ) : null}
      {/* <!-- Buy Page --> */}
      {currentNode.name === "buy" ? (
        <BuyPage
          navigateFn={(target) => {
            onPageChange(target);
          }}
          handleBack={() => goBack()}
          handleReset={() => {
            handleCLoseModel();
          }}
        />
      ) : null}

      {/* <!-- Buy Tools --> */}
      {currentNode.name === "tools" && getParentOfCurrentNode() === "buy" ? (
        <BuyToolsPage
          navigateFn={(target) => {
            onPageChange(target);
          }}
          handleBack={() => goBack()}
          handleReset={() => {
            handleCLoseModel();
          }}
        />
      ) : null}

      {/*  <!-- Buy Resources --> */}
      {currentNode.name === "resources" &&
      getParentOfCurrentNode() === "buy" ? (
        <BuyResourcesPage
          navigateFn={(target) => {
            onPageChange(target);
          }}
          handleBack={() => goBack()}
          handleReset={() => {
            handleCLoseModel();
          }}
        />
      ) : null}

      {/*  <!-- Sell Page --> */}
      {currentNode.name === "sell" ? (
        <SellPage
          navigateFn={(target) => {
            onPageChange(target);
          }}
          handleBack={() => goBack()}
          handleReset={() => {
            handleCLoseModel();
          }}
        />
      ) : null}

      {/*     <!-- Sell Tools --> */}
      {currentNode.name === "tools" && getParentOfCurrentNode() === "sell" ? (
        <SellToolsPage
          navigateFn={(target) => {
            onPageChange(target);
          }}
          handleBack={() => goBack()}
          handleReset={() => {
            handleCLoseModel();
          }}
        />
      ) : null}

      {/* <!-- Sell Resources --> */}
      {currentNode.name === "resources" &&
      getParentOfCurrentNode() === "sell" ? (
        <SellResourcesPage
          navigateFn={(target) => {
            onPageChange(target);
          }}
          handleBack={() => goBack()}
          handleReset={() => {
            handleCLoseModel();
          }}
        />
      ) : null}

      {/*  <!-- Buy & Sell Page --> */}
      {currentNode.name === "sell-buy" ? (
        <SellBuyPage
          navigateFn={(target) => {
            onPageChange(target);
          }}
          handleBack={() => goBack()}
          handleReset={() => {
            handleCLoseModel();
          }}
        />
      ) : null}

      {/* <!-- Buy & Sell Tools --> */}
      {currentNode.name === "tools" &&
      getParentOfCurrentNode() === "sell-buy" ? (
        <SellBuyToolsPage
          navigateFn={(target) => {
            onPageChange(target);
          }}
          handleBack={() => goBack()}
          handleReset={() => {
            handleCLoseModel();
          }}
        />
      ) : null}

      {/* <!-- Buy & Sell Resources --> */}
      {currentNode.name === "resources" &&
      getParentOfCurrentNode() === "sell-buy" ? (
        <SellBuyResourcesPage
          navigateFn={(target) => {
            onPageChange(target);
          }}
          handleBack={() => goBack()}
          handleReset={() => {
            handleCLoseModel();
          }}
        />
      ) : null}
    </div>
  );
};

export default MobileNavMenus;
